// extracted by mini-css-extract-plugin
module.exports = {"comp":"AU5_comp__gq_sP"};